module.exports = __webpack_public_path__ + "img/case_icon1.d30ad526.png";